import Panel from "@src/components/box/Panel";
import UserWidget from "@src/components/elements/UserWidget";
import getUserInformation from "@src/utils/getUserInformation";
import { User } from "@src/utils/user";

type Props = { user: User; minimized?: boolean };

const ClubContainer = ({ user, minimized = true }: Props) => {
  return (
    <div className="flex justify-between">
      <Panel>
        <div>
          <div className="flex flex-col text-sm">
            <UserWidget user={user} showName={true} follow={false} verified={true} />

            {!minimized && (
              <div className="flex flex-col gap-1">
                <div className="flex w-full flex-col justify-between text-xs">
                  <div className="flex flex-row gap-x-1">
                    <div
                      className="truncate"
                      dangerouslySetInnerHTML={getUserInformation(user, {
                        zipCode: true,
                      })}
                    />
                  </div>
                  <div className="flex flex-row gap-x-1">
                    <div
                      className="truncate"
                      dangerouslySetInnerHTML={getUserInformation(user, {
                        street: true,
                      })}
                    />
                  </div>
                  <div className="flex flex-row gap-x-1">
                    <div
                      className="truncate"
                      dangerouslySetInnerHTML={getUserInformation(user, {
                        phone_number: true,
                      })}
                    />
                  </div>
                  <div className="flex flex-row gap-x-1">
                    <div
                      className="truncate"
                      dangerouslySetInnerHTML={getUserInformation(user, {
                        website: true,
                      })}
                    />
                  </div>
                  <div className="flex flex-row gap-x-1">
                    <div
                      className="truncate"
                      dangerouslySetInnerHTML={getUserInformation(user, {
                        email: true,
                      })}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Panel>
    </div>
  );
};

export default ClubContainer;
